import {useSyncExternalStore} from 'react';

// Module-scoped keyword store (FNP-815): the search box in the table and the list hook
// that filters on it are separate consumers, and so is the Reload button. With a
// per-component useState each held its own keyword, so search narrowed nothing and Reload
// refetched a different cache entry than the table showed (FNP-1883).
let globalKeyword = '';
const listeners: Set<() => void> = new Set();

const notify = (keyword: string) => {
    globalKeyword = keyword;
    listeners.forEach(listener => listener());
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

const getSnapshot = () => globalKeyword;

// Test-only: the store outlives a test case, so tests reset it or leak state.
export const __resetUsageEventsSearchForTesting = () => {
    notify('');
};

export const useUsageEventsSearch = () => {
    const keyword = useSyncExternalStore(subscribe, getSnapshot);

    const handleFilterByKeyword = (newKeyword: string) => {
        notify(newKeyword);
    };

    return {keyword, handleFilterByKeyword};
};
